/* eslint-disable import/named */
import React, { useState, useEffect } from "react";
import { bool, shape, func } from "prop-types";
import * as i18nUtils from "util/i18n";
import { addUtcOffset } from "util/date";
import GridTable from "pages/_components/GridTable/GridTable";
import CustomText from "pages/_components/CustomText/CustomText";
import FormattedDate from "pages/_components/FormattedDate";

import FormattedAmount from "pages/_components/FormattedAmount";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import InfoTag from "pages/echeck/components/InfoTag";
import CustomData from "pages/_components/CustomData/CustomData";
import EcheqCheckbox from "pages/discounts/DiscountCreation/components/EcheqCheckbox";
import MainContainer from "pages/_components/MainContainer";
import Drawer from "pages/_components/Drawer/Drawer";
import VepDetail from "pages/afipPaymentLink/components/VepDetail";

const VepsInProgressItem = ({ vep, isDesktop, handleCheckVep, handleOpenEliminarForm, setVepToDelete, isChecked }) => {
    const [check, setCheck] = useState(false);

    const [openSidebarDetail, setOpenSidebarDetail] = useState(false);

    const handleDetail = () => {
        setOpenSidebarDetail(true);
    };
    const onClose = () => {
        setOpenSidebarDetail(false);
    };

    useEffect(() => {
        if (isChecked) {
            setCheck(true);
        }
    }, [isChecked]);

    const options = [
        {
            text: "vep.payment.action.detail",
            textType: "I18N",
            func: () => handleDetail(),
        },
        {
            text: "vep.payment.action.delete",
            textType: "I18N",
            func: () => {
                setVepToDelete(vep);
                handleOpenEliminarForm();
            },
        },
    ];

    const handleCheck = (id, value) => {
        setCheck(value);
        handleCheckVep({ id, value });
    };

    const sanitizeVeps = (id) => {
        return id.replace(/^00/, "");
    };

    return (
        <>
            <GridTable.Data columnStart={1} rowStart={1}>
                <EcheqCheckbox name={vep.id} checked={check} onChange={(value) => handleCheck(vep.id, value)} />
            </GridTable.Data>
            <GridTable.Data
                className="align-items-center"
                columnStart={isDesktop ? 2 : 1}
                rowStart={isDesktop ? 1 : 2}
                alignX={isDesktop ? "center" : "flex-start"}>
                {isDesktop ? (
                    <CustomText className="ellipsis-vep" text={sanitizeVeps(vep.id)} textType="TEXT" />
                ) : (
                    <CustomData
                        titleText="vep.payment.number"
                        titleTextType="I18N"
                        valueText={sanitizeVeps(vep.id)}
                        valueTextType="TEXT"
                    />
                )}
            </GridTable.Data>
            <GridTable.Data
                className="align-items-center"
                columnStart={isDesktop ? 3 : 1}
                rowStart={isDesktop ? 1 : 3}
                alignX={isDesktop ? "center" : "flex-start"}>
                {isDesktop ? (
                    <FormattedDate date={addUtcOffset(vep.expirationDate)} dateFormat="DD/MM/YYYY" />
                ) : (
                    <CustomData
                        titleText="vep.payment.dueDate"
                        titleTextType="I18N"
                        valueText={addUtcOffset(vep.expirationDate)}
                        valueTextType="DATE"
                    />
                )}
            </GridTable.Data>
            <GridTable.Data
                className="align-items-center"
                columnStart={isDesktop ? 4 : 1}
                rowStart={isDesktop ? 1 : 4}
                alignX={isDesktop ? "center" : "start"}>
                {isDesktop ? (
                    <CustomText text={vep.cuitOrigin} textType="TEXT" />
                ) : (
                    <CustomData
                        titleText="vep.payment.cuitCreator"
                        titleTextType="I18N"
                        valueText={vep.cuitOrigin}
                        valueTextType="TEXT"
                    />
                )}
            </GridTable.Data>
            <GridTable.Data
                className="align-items-center"
                columnStart={isDesktop ? 5 : 1}
                rowStart={isDesktop ? 1 : 5}
                alignX={isDesktop ? "center" : "start"}>
                {isDesktop ? (
                    <CustomText text={vep.cuitTaxpayer} textType="TEXT" />
                ) : (
                    <CustomData
                        titleText="vep.payment.cuitTaxpayer"
                        titleTextType="I18N"
                        valueText={vep.cuitTaxpayer}
                        valueTextType="TEXT"
                    />
                )}
            </GridTable.Data>
            <GridTable.Data
                className="align-items-center"
                columnStart={isDesktop ? 6 : 1}
                rowStart={isDesktop ? 1 : 6}
                alignX={isDesktop ? "center" : "start"}>
                {isDesktop ? (
                    <CustomText text={vep.description} textType="TEXT" />
                ) : (
                    <CustomData
                        titleText="vep.payment.description"
                        titleTextType="I18N"
                        valueText={vep.description}
                        valueTextType="TEXT"
                    />
                )}
            </GridTable.Data>
            <GridTable.Data
                className="align-items-center vep-amount"
                columnStart={isDesktop ? 7 : 1}
                rowStart={isDesktop ? 1 : 7}
                alignX={isDesktop ? "center" : "start"}>
                {isDesktop ? (
                    <FormattedAmount currency={vep.currency} quantity={vep.amount} />
                ) : (
                    <CustomData
                        titleText="vep.payment.amount"
                        titleTextType="I18N"
                        valueText={<FormattedAmount currency={vep.currency} quantity={vep.amount} />}
                        valueTextType="TEXT"
                    />
                )}
            </GridTable.Data>
            <GridTable.Data
                className="tags-wrapper align-items-center ellipsis-vep"
                columnStart={isDesktop ? 8 : 2}
                rowStart={1}
                alignX={isDesktop ? "center" : "end"}>
                <InfoTag
                    type="info"
                    message={i18nUtils.get("vep.payment.status.PENDIENTE_PAGO", "Pendiente")}
                    tagBackground="warning"
                />
            </GridTable.Data>
            <GridTable.Data columnStart={isDesktop ? 9 : 3} rowStart={1} rowWidth={1} alignX="end">
                <CustomButton pullRight icon="images/figma/icon/menu-mobile.svg" options={options} />
            </GridTable.Data>
            <MainContainer className="vep">
                <Drawer
                    openSidebar={openSidebarDetail}
                    onClose={onClose}
                    isFullHeight={!isDesktop}
                    enableCloseButton={!!isDesktop}>
                    <VepDetail vep={vep} isDesktop={isDesktop} handleClose={onClose} openForm={openSidebarDetail} />
                </Drawer>
            </MainContainer>
        </>
    );
};

VepsInProgressItem.propTypes = {
    vep: shape({}).isRequired,
    isDesktop: bool.isRequired,
    handleCheckVep: bool.isRequired,
    handleOpenEliminarForm: func.isRequired,
    setVepToDelete: func.isRequired,
};

export default VepsInProgressItem;
